<template>
  <PageHeader>
    <template #header-title>
      {{ $t('Shared with you') }}
    </template>
  </PageHeader>

  <div class="tw-max-h-full">
    <GraphqlDataTable
      :query
      :order-by="initialOrder"
      :filter-black-list="['accounts', 'accountTypes', 'isActive']"
      :quick-filters="['clientCompanies']"
      :additional-query-variables="additionalVariables"
      :hide-filters="true"
      :max-height-adjustment="30"
      data-test="freelancer-shared-jobs-table"
    >
      <template #action="{ row }">
        <JobShareActionColumn :row="row" />
      </template>
      <template #no-results>
        {{ $t("No jobs have been shared with you yet. Once they are, they'll be listed here.") }}
      </template>
    </GraphqlDataTable>
  </div>
</template>

<script lang="ts" setup>
import { TypedQueryDocumentNode } from 'graphql/index'
import GraphqlDataTable from '@/components/GraphqlDataTable/GraphqlDataTable.vue'
import PageHeader from '@/components/PageHeader.vue'
import { graphql } from '@/gql'
import { AccountType, JobShareOrderByColumn, SortOrder } from '@/gql/graphql'
import { $t } from '@/composables/translation'
import JobShareActionColumn from '@/components/GraphqlDataTable/columns/JobShare/JobShareActionColumn.vue'

const query = graphql(`
  query FreelancerSharedJobsQuery(
    $page: Int!
    $first: Int!
    $accountTypes: [AccountType!]
    $isActive: Boolean
    $clientCompanies: [ID!]
    $orderBy: [JobShareOrderByClauseInput!]
  ) {
    jobShares(
      page: $page
      first: $first
      accountTypes: $accountTypes
      isActive: $isActive
      companies: $clientCompanies
      orderBy: $orderBy
    ) {
      data {
        job {
          ...JobTitleColumn
          ...JobLocationPreferenceColumn
        }
        ...JobShareCompanyColumn
        ...JobShareCreatedAtColumn
      }
    }
  }
`) as TypedQueryDocumentNode

const additionalVariables = {
  accountTypes: [AccountType.Worker],
  isActive: true,
}

const initialOrder = {
  field: JobShareOrderByColumn.CreatedAt,
  order: SortOrder.Desc,
}
</script>
